import { Box, Button, Divider, Grid, Typography, useMediaQuery, useTheme } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import NeshanMap from 'react-neshan-map-leaflet';
import { newBranches } from '../../feature/api/branch';

const NewBranch = () => {
  const theme = useTheme()
  const phone = useMediaQuery(theme.breakpoints.between(280, 610))
  const dispatch = useDispatch()
  const branches = useSelector(state => state.branches.newBranch)
  const [lat, setLat] = useState()
  const [long, setLong] = useState()
  const [id, setId] = useState()
  const [show, setShow] = useState(false)
  const [button, setButton] = useState(false)
  useEffect(() => {
    dispatch(newBranches())

  }, [])

  var flightNumber = 0;




  return (
    <Box height={"100vh"}>
      <Grid container bgcolor={"#040404"} p="10px" height={'auto'} display={"flex"} gap={2} justifyContent={"center"} alignItems={"center"}  >
        <Grid item lg={5} xl={5} md={5} sm={10} xs={12} display={"flex"} gap={2} alignItems={"center"} bgcolor={"#EE7B00"} p="10px" borderRadius={"13px"} justifyContent={"center"}>
          <Typography color="#fff" > مجموع شعب در حال راه اندازی :  </Typography>
          <Typography fontWeight={"bold"} color="#fff"> {branches?.count} </Typography>
        </Grid>
        <Grid item lg={5} xl={5} md={5} sm={10} xs={12} display={"flex"} gap={2} alignItems={"center"} bgcolor={"#EE7B00"} p="10px" borderRadius={"13px"} justifyContent={"center"}>
          <Typography color="#fff"> مجموع اشتغال زایی  : </Typography>
          <Typography fontWeight={"bold"} color="#fff"> {branches?.sumemp} نفر </Typography>
        </Grid>

      </Grid>
      <Box width={"100%"} height={"85%"} key={branches} position={"relative"} display={"flex"} alignItems={"center"} justifyContent={"center"}>

        <NeshanMap

          style={{ width: "100%", height: '100%', zIndex: 90, opacity: show ? .5 : 1 }}
          options={{
            // key: 'web.da31340343c645839584a7235f60d907',
            key: 'web.xTsQNqQ9zHqcqpyFLE2jnvnSWxt94atWbvB50RMY',
            maptype: 'dreamy',
            poi: true,
            traffic: false,
            center: [Number(32.6514999), Number(51.6757409)],
            zoom: 5.3,
            gestureHandling: true,

          }}
          onInit={(L, myMap) => {
            // setTimeout(function () { myMap.invalidateSize() }, 100);
            var mark = L.marker([lat ? lat : Number(32.6514999), long ? long : Number(51.6757409)], { autoPan: true }).addTo(myMap)

            if (branches?.length !== 0) {
              let c = branches?.list[flightNumber]?.location?.split(',')
              setLat(Number(c[0]))
              setLong(Number(c[1]))
              setId(branches?.list[flightNumber]?.id)
              myMap.flyTo([Number(32.6514999), Number(51.6757409)], 5.3);
              setTimeout(() => {
                myMap.flyTo([Number(c[0]), Number(c[1])], 16);

              }, 5000)

              flightNumber++;

              if (flightNumber >= branches?.list?.length) {
                flightNumber = 0;
              }
            }


            function changelocation() {

              if (branches?.length !== 0) {
                let c = branches?.list[flightNumber]?.location?.split(',')
                setLat(Number(c[0]))
                setLong(Number(c[1]))
                setId(branches?.list[flightNumber]?.id)
                // myMap.invalidateSize()

                myMap.flyTo([Number(32.6514999), Number(51.6757409)], 5.3);
                setTimeout(() => {
                  // myMap.invalidateSize()


                  myMap.flyTo([Number(c[0]), Number(c[1])], 16);

                }, 5000)

                flightNumber++;

                if (flightNumber >= branches?.list?.length) {
                  flightNumber = 0;
                }
              }
            }

            function Timer(fn, t) {
              var timerObj = setInterval(fn, t);

              this.stop = function () {
                if (timerObj) {
                  clearInterval(timerObj);
                  timerObj = null;
                }
                return this;
              }

              // start timer using current settings (if it's not already running)
              this.start = function () {
                if (!timerObj) {
                  this.stop();
                  timerObj = setInterval(fn, t);
                }
                return this;
              }

              // start with new or original interval, stop current interval
              this.reset = function (newT = t) {
                t = newT;
                return this.stop().start();
              }
            }




            var timer = new Timer(function () {
              changelocation()
            }, 30000);



            myMap.on('move', function () {
              mark.setLatLng(myMap.getCenter());
              let e = document.getElementById('modal')
              e.style.display = "none"
              setShow(false)


            });


            myMap.on('moveend', function () {
              timer.start();

              let e = document.getElementById('modal')
              let a = myMap.getZoom()
              setButton(false)
              if (a == 16) {
                e.style.display = "block"
                e.style.transition = " display 2s ease-in-out"
                document.getElementById('butt').addEventListener('click', () => {
                  timer.stop()
                  changelocation()

                })
                setShow(true)







              }
            });



          }}

        />

        <div id="modal" style={{}}>
          {branches?.list?.map((item) =>
            item.id == id &&
            <Box display={"flex"} flexDirection={"column"} justifyContent={"center"} alignItems={"flex-end"} sx={{ backgroundColor: "#EEF7FF87", backdropFilter: 'blur(2px)' }} style={{ width: phone ? "350px" : '350px' }}>
              <Box>

                <img src={item.image} width={"100%"} />
              </Box>
              <Box display={"flex"} justifyContent={"flex-start"} p={phone ? "10px" : "5px 20px"} width={"100%"} >

                <Box display={"flex"} flexDirection={"column"} gap={2}>
                  <Box display={"flex"} alignItems="center" >
                    <img src="/images/darkloc.svg" />
                    <Typography fontWeight={"bold"}>استان : </Typography>
                    <Typography fontWeight={"bold"}>{item.province}</Typography>
                  </Box>
                  <Box display={"flex"} alignItems="center" >
                    <img src="/images/darkloc.svg" />

                    <Typography variant='body2'>شهر : </Typography>
                    <Typography variant='body2'>{item.city}</Typography>
                  </Box>
                  <Box display={"flex"} alignItems="center" >
                    <Typography variant='body2'> کاربری شعبه : </Typography>
                    <Typography variant='body2'>{item.branchtype}</Typography>
                  </Box>
                  <Divider sx={{ bgcolor: '#000' }} />
                  <Box display={"flex"} alignItems="center" >
                    <Typography color="#804C23"> اشتغال زایی برای {item.employee} نفر </Typography>
                  </Box>
                  <Box display={"flex"} alignItems="center" >
                    <Typography color="#804C23">   افتتاح  {item.date} </Typography>
                  </Box>

                </Box>
              </Box>
              <Button variant='contained' id="butt" >شعبه بعد</Button>
            </Box>
          )}
        </div>
      </Box>
    </Box>
  )
}

export default NewBranch
